import { Component, Vue, PropSync, Emit, Watch } from 'vue-property-decorator';
import TitleButton from '@/components/general/titlebutton/TitleButton.vue';
import { QuickMenuData } from '@/models/general/QuickMenuData';

@Component({
    components: {
        TitleButton,
    },
})
export default class QuickSelectMenuComponent extends Vue {
    @PropSync('isVisible', { type: Boolean }) public syncedIsVisible!: boolean;
    @PropSync('data', { type: Object }) public syncedData!: QuickMenuData;

    public fab: boolean = false;

    // tslint:disable-next-line: no-empty
    public mounted() {

    }

    @Emit('value')
    public emitValue(machineIdentifier: string): string {
        return machineIdentifier;
    }

    @Watch('syncedIsVisible')
    public OnSyncedIsVisibleChanged(newValue: boolean, oldValue: boolean) {
        if (this.fab === true) {
            this.fab = false;
        }
    }

    public OnItemClicked(machineIdentifier: string) {
        this.emitValue(machineIdentifier);
    }

    public getItems() {
        return this.syncedData.items.filter((item) => item.isAdded === false && item.show === true);
    }
}
